import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const logAccess = async (userData, action, details = {}) => {
  try {
    const companyId = userData?.currentCompanyId || userData?.companyId || '';
    await addDoc(collection(db, 'accessLogs'), {
      userId: userData?.uid || 'anonymous',
      userEmail: userData?.email || 'unknown',
      userName: userData?.name || userData?.displayName || 'Unknown User',
      userRole: userData?.role || 'unknown',
      companyId,
      action,
      details: {
        ...details,
        path: details.path || (typeof window !== 'undefined' ? window.location.pathname : '')
      },
      timestamp: serverTimestamp(),
      ip: await getUserIP()
    });
  } catch (error) {
    console.error('Erro ao registrar log:', error);
  }
};

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    return 'unknown';
  }
};

const accessLogger = {
  logAccess
};

export default accessLogger;
